import React, { useMemo } from 'react';
import { StyledBody } from '../../CSSstyles';
import {
  getResultTimeCopy,
  offersInHouseSampleAnalysis,
  offersSendOutSampleAnalysis,
} from '../../util';
import { safeGet } from '../../../../../../core/util/object';

type Props = {
  details: any;
  inHouseResultTime?: string;
  sendOutResultTime?: string;
};

const ResultTimeBulletPoint = ({ details, inHouseResultTime, sendOutResultTime }: Props) => {
  const sampleAnalysis = safeGet(details)('sampleAnalysis');

  const resultTimeCopy = useMemo(() => {
    if (inHouseResultTime || sendOutResultTime) return getResultTimeCopy(details);
    return null;
  }, [details, inHouseResultTime, sendOutResultTime]);
  const hasOneTypeOfResultTimeData =
    (inHouseResultTime && !sendOutResultTime) || (!inHouseResultTime && sendOutResultTime);

  const hasSampleAnalysisData =
    offersInHouseSampleAnalysis(sampleAnalysis) || offersSendOutSampleAnalysis(sampleAnalysis);

  if (!hasOneTypeOfResultTimeData || !hasSampleAnalysisData) return null;

  return (
    <li>
      <StyledBody>{resultTimeCopy}</StyledBody>
    </li>
  );
};

export default ResultTimeBulletPoint;
